var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFontIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.433 9.013-.854 2.304a1.025 1.025 0 0 1-.984.683c-.375 0-.672-.155-.892-.466a.99.99 0 0 1-.124-.99L4.438.7a1.04 1.04 0 0 1 .411-.512C5.04.062 5.247 0 5.47 0h.88c.236 0 .447.063.634.19.186.126.321.297.405.514l3.833 9.846a.985.985 0 0 1-.125.99c-.221.306-.522.46-.902.46-.235 0-.45-.065-.643-.195a1.069 1.069 0 0 1-.416-.53L8.32 9.013H3.433zM4.087 7.2h3.58L5.925 2.357H5.84L4.087 7.2zm10.884-.266h-1.668a.93.93 0 0 1-.678-.268A.896.896 0 0 1 12.35 6a.93.93 0 0 1 .952-.934h1.668V3.429a.89.89 0 0 1 .277-.666.94.94 0 0 1 .68-.268.931.931 0 0 1 .952.934v1.637h1.668c.27 0 .496.09.678.268.183.18.274.401.274.666a.896.896 0 0 1-.274.666.93.93 0 0 1-.678.268H16.88v1.637a.896.896 0 0 1-.274.666.93.93 0 0 1-.678.268.933.933 0 0 1-.68-.272.898.898 0 0 1-.277-.667V6.934z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontIncrease);
export default __webpack_public_path__ + "static/media/font-increase.a1e49d608e509829761621cf154bcc13.svg";
export { ForwardRef as ReactComponent };